import { Button, styled } from '@mui/material';
export var CreateButton = styled(Button)(function () { return ({
    color: 'white',
    borderColor: 'white',
    borderRadius: '30px',
    textTransform: 'none',
    padding: '0.5em 1.5em',
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderColor: 'white',
    },
}); });
